import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'

/* The closing call to action shared by every page except Contact. */
export const ContactCta: FC = (): ReactNode => {
    return (
        <section id='work-with-me' className='px-5 py-20 sm:px-8 lg:py-28'>
            <div className='relative mx-auto max-w-7xl overflow-hidden rounded-3xl bg-primary px-6 py-16 text-primary-foreground sm:px-12 lg:px-20 lg:py-24'>
                <div aria-hidden='true' className='pointer-events-none absolute -right-24 -bottom-40 hidden h-[30rem] w-80 rounded-t-full border border-primary-foreground/20 md:block' />
                <div aria-hidden='true' className='pointer-events-none absolute -right-4 -bottom-40 hidden h-[24rem] w-64 rounded-t-full border border-primary-foreground/20 md:block' />

                <div className='relative max-w-2xl'>
                    <p className='text-xs font-medium uppercase tracking-[0.24em]'>
                        Work with me
                    </p>

                    <h2 className='mt-5 font-heading text-4xl leading-[1.1] tracking-tight sm:text-5xl'>
                        Planning a room of your own?
                    </h2>

                    <p className='mt-6 max-w-xl text-lg leading-relaxed'>
                        Whether it's a single room or a whole home, tell me what you have in mind and we'll find the right place to begin.
                    </p>

                    <Link
                        href='/contact'
                        className={buttonVariants({ variant: 'inverse', size: 'lg', className: 'group mt-9' })}
                    >
                        Start a conversation
                        <ArrowRight className='transition-transform group-hover:translate-x-0.5' />
                    </Link>
                </div>
            </div>
        </section>
    )
}
